const namespaced = true

const state = {
  inventorySettings: [],
  recyclerSettings: []
}

const mutations = {
  setOverrideOm61InventorySettings (state, data) {
    state.inventorySettings = data.inventorySettings
    state.recyclerSettings = data.recyclerSettings
  }
}

const getters = {
  getOverrideOm61InventorySettings: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideOm61InventorySettings.js